module.exports = __webpack_public_path__ + "static/img/friend10.f52664e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/friend10.jpg
// module id = m0c9
// module chunks = 1